function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white",
  stroke: "none"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.829 11.5609C13.4172 11.5609 14.7925 10.9912 15.9162 9.86733C17.0399 8.74362 17.6096 7.36868 17.6096 5.78025C17.6096 4.19237 17.0399 2.81725 15.916 1.69317C14.7921 0.569639 13.417 0 11.829 0C10.2405 0 8.86559 0.569639 7.74188 1.69335C6.61816 2.81707 6.04834 4.19218 6.04834 5.78025C6.04834 7.36868 6.61816 8.7438 7.74206 9.86751C8.86596 10.991 10.2411 11.5609 11.829 11.5609Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M21.9435 18.4547C21.9111 17.9871 21.8455 17.477 21.749 16.9383C21.6516 16.3955 21.5262 15.8825 21.376 15.4136C21.2209 14.9289 21.01 14.4502 20.7493 13.9916C20.4786 13.5155 20.1608 13.1009 19.8041 12.7598C19.4311 12.403 18.9744 12.116 18.4463 11.9067C17.9201 11.6985 17.3369 11.5931 16.7131 11.5931C16.4681 11.5931 16.2311 11.6936 15.7736 11.9915C15.492 12.1752 15.1625 12.3876 14.7949 12.6225C14.4805 12.8228 14.0546 13.0105 13.5285 13.1804C13.0153 13.3465 12.4942 13.4307 11.9798 13.4307C11.4655 13.4307 10.9445 13.3465 10.4308 13.1804C9.90524 13.0107 9.47934 12.823 9.16532 12.6227C8.80112 12.39 8.47153 12.1775 8.18571 11.9913C7.72868 11.6934 7.49156 11.5929 7.24656 11.5929C6.62254 11.5929 6.03954 11.6985 5.51347 11.9069C4.98577 12.1158 4.52892 12.4028 4.15557 12.76C3.79907 13.1013 3.48101 13.5157 3.21075 13.9916C2.95019 14.4502 2.73925 14.9287 2.58398 15.4137C2.43402 15.8827 2.30859 16.3955 2.21118 16.9383C2.11468 17.4762 2.04913 17.9865 2.01672 18.4553C1.98486 18.9145 1.96875 19.3911 1.96875 19.8725C1.96875 21.1253 2.367 22.1395 3.15234 22.8875C3.92797 23.6256 4.95427 24.0001 6.20231 24.0001H17.7584C19.0065 24.0001 20.0324 23.6258 20.8082 22.8875C21.5937 22.1401 21.992 21.1257 21.992 19.8723C21.9918 19.3888 21.9755 18.9118 21.9435 18.4547Z"
}));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 23.9999,
  height: 24
})));

function SvgLogin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.72e4c08acd3904c47a8d20fcff616266.svg";
export { ForwardRef as ReactComponent };